<div class="marker-title-wrapper">
    <sp-status-label [status]="stage"></sp-status-label>
    <span class="template-title">{{ title }}</span>
</div>
<div class="template-body"[innerHTML]="body"></div>
